import PropTypes from 'prop-types';
import React from 'react';

import { EXTERNAL_ORDER_QUANTITY_LIMITS } from '../../../../../../constants';

import {
  CellContainer,
  CheckButton,
  CheckIcon,
  PREPARED_QUANTITY_VARIANT,
  QuantityInput,
} from './styledComponents';

const CHECK_ICON_BY_VARIANT = {
  [PREPARED_QUANTITY_VARIANT.NEUTRAL]: '/images/inpulse/check-black-small.svg',
  [PREPARED_QUANTITY_VARIANT.COMPLIANT]: '/images/inpulse/check-white-small.svg',
  [PREPARED_QUANTITY_VARIANT.NON_COMPLIANT]: '/images/inpulse/check-white-small.svg',
  [PREPARED_QUANTITY_VARIANT.DISABLED]: '/images/inpulse/check-dmgrey-small.svg',
};

/** Quantities are counts of whole products: anything but a digit is dropped as it is typed. */
const NON_DIGIT_CHARACTERS = /\D/g;

/**
 * BDL quantity of a line in preparation, next to its preparer tick. The tick is a visual pointing
 * only — saving goes through the page button — and tints the whole cell: green when the line is
 * delivered as ordered, orange otherwise, neutral while unticked. Without the edit right both
 * controls are disabled and the tint is muted, whatever the tick.
 */
const PreparedQuantityCell = (props) => {
  const { quantity, bdcQuantity, isChecked, isDisabled, onQuantityChange, onToggleChecked } = props;

  const getVariant = () => {
    if (isDisabled) {
      return PREPARED_QUANTITY_VARIANT.DISABLED;
    }

    if (!isChecked) {
      return PREPARED_QUANTITY_VARIANT.NEUTRAL;
    }

    if ((quantity ?? 0) === bdcQuantity) {
      return PREPARED_QUANTITY_VARIANT.COMPLIANT;
    }

    return PREPARED_QUANTITY_VARIANT.NON_COMPLIANT;
  };

  const variant = getVariant();

  // An emptied input stays empty on screen — a null quantity only becomes a 0 when it is saved.
  const handleQuantityChange = (event) => {
    const digits = event.target.value.replace(NON_DIGIT_CHARACTERS, '');

    if (!digits) {
      onQuantityChange(null);

      return;
    }

    onQuantityChange(Math.min(parseInt(digits, 10), EXTERNAL_ORDER_QUANTITY_LIMITS.max));
  };

  return (
    <CellContainer variant={variant}>
      <QuantityInput
        disabled={isDisabled}
        value={quantity ?? ''}
        variant={variant}
        onChange={handleQuantityChange}
      />
      <CheckButton
        disabled={isDisabled}
        type={'button'}
        variant={variant}
        onClick={onToggleChecked}
      >
        <CheckIcon src={CHECK_ICON_BY_VARIANT[variant]} />
      </CheckButton>
    </CellContainer>
  );
};

PreparedQuantityCell.propTypes = {
  quantity: PropTypes.number,
  bdcQuantity: PropTypes.number,
  isChecked: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  onQuantityChange: PropTypes.func.isRequired,
  onToggleChecked: PropTypes.func.isRequired,
};

PreparedQuantityCell.defaultProps = {
  quantity: null,
  bdcQuantity: 0,
};

export default PreparedQuantityCell;
